export default "__VITE_ASSET__B9q3aTBR__"